import { useQuery } from "@tanstack/react-query";
import { getAdminUserById } from "@/services/role-access.service";

export const useAdminUserById = (userId, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["admin-user", userId],
    queryFn: () => getAdminUserById(userId),
    enabled: enabled && !!userId,
    select: (data) => data?.data,
    ...options,
  });
};
